import React, { useContext, useEffect, useState } from "react"
import { CadastroDTO, Usuario, UsuarioEnderecos } from "../../../../provider/auth/AuthProps";
import { Autocomplete, Box, Button, Divider, Drawer, Grid, IconButton, TextField, Typography } from "@mui/material";
import BoxComponent from "../../../../components/Box/BoxComponent";
import LabelComponent from "../../../../components/Label/LabelComponent";
import { CampoPedidoInputStyle, CampoPedidoLabelStyle, CampoPedidoStyle } from "../modal/novo_pedido/InfoPedidoComponent";
import TextFieldComponent from "../../../../components/TextField/TextFieldComponent";
import SelectComponent from "../../../../components/Select/SelectComponent";
import { MunicipioDTO, UfDTO } from "../../../../interface/Localidade";
import { AuthContext } from "../../../../provider/auth/AuthContext";
import { localidadeService } from "../../../../service/LocalidadeService";
import TypographyComponent from "../../../../components/Typography/ThypographyComponent";
import ButtonComponent from "../../../../components/Button/ButtonComponent";
import { enderecoService } from "../../../../service/EnderecoService";
import NovoEnderecoFields from "./NovoEnderecoFields";

interface CadastroUsuarioDrawerProps {
    open: boolean;
    onClose: (usuario: Usuario, endereco: UsuarioEnderecos) => void;
    userData?: Usuario;
    //onChangeUserData: (usuario: Usuario) => void;
    onSubmit: (data: CadastroDTO) => void;
}

const DadosUsuarioDrawer = (props: CadastroUsuarioDrawerProps) => {
    const [adicionandoEndereco, setAdicionandoEndereco] = useState(false);

    const [endereco, setEndereco] = useState<UsuarioEnderecos>();
    const [enderecoSelecionado, setEnderecoSelecionado] = useState<number | null>(null);
    const [enderecos, setEnderecos] = useState<UsuarioEnderecos[]>([]);

    //const { token } = useContext(AuthContext);

    // Altera o estado dos endereços
    useEffect(() => {
        if (props.userData) setEnderecos(props.userData?.enderecos);
    }, [props.userData?.enderecos])

    const [dadosUsuario, setDadosUsuario] = useState<Usuario>();

    useEffect(() => {
        setEnderecoSelecionado(null);

        if (props.userData) {
            setDadosUsuario(props.userData);
        } else {
            setDadosUsuario(undefined);
            setEnderecos([]);
        }
    }, [props.open == true])



    const handleChange = (field: keyof Usuario) =>
        (event: React.ChangeEvent<HTMLInputElement>) => {

            setDadosUsuario({
                ...dadosUsuario,
                [field]: event.target.value
            } as Usuario);
        };

    const handleChangeEndereco = (campo: string, valor: string) => {
        setEndereco({
            ...endereco,
            [campo]: valor
        } as UsuarioEnderecos);
    }

    // Eventos de registro
    const [errors, setErrors] = useState<Record<string, string>>({});

    const validateForm = () => {
        const newErrors: Record<string, string> = {};

        if (!dadosUsuario?.nome?.trim()) {
            newErrors.nome = "Nome é obrigatório";
        }

        if (!dadosUsuario?.telefoneCompleto?.trim()) {
            newErrors.telefone = "Telefone é obrigatório";
        }

        if (!enderecoSelecionado && enderecoSelecionado !== 0) {
            newErrors.endereco = "Selecione um endereço";
        }

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };

    const handleSaveEndereco = (event: any) => {
        event.preventDefault();

        if (endereco) {

            const novoEndereco = {
                ...endereco,
                enderecoCompleto: enderecoService.createEnderecoCompleto(endereco)
            };

            setEnderecos(prev => [...prev, novoEndereco]);

            setEnderecoSelecionado(enderecos.length);

            setEndereco({
                id: 0,
                nome: "",
                enderecoCompleto: "",
                endereco: "",
                rua: "",
                quadra: "",
                numero: "",
                bairro: "",
                cep: "",
                cidade: "",
                estado: "",
                pontoReferencia: ""
            });
            setAdicionandoEndereco(false);
        }
    }

    const handleCancelaEndereco = () => {
        setEndereco({
            id: 0,
            nome: "",
            enderecoCompleto: "",
            endereco: "",
            rua: "",
            quadra: "",
            numero: "",
            bairro: "",
            cep: "",
            cidade: "",
            estado: "",
            pontoReferencia: ""
        });

        setAdicionandoEndereco(false);
    }

    const handleCloseDrawer = () => {
        const isValid = validateForm();

        if (!isValid) return;

        if (dadosUsuario != null && enderecoSelecionado != null) props.onClose(dadosUsuario, enderecos[enderecoSelecionado]);
    }

    return (
        <Drawer
            anchor="right"
            open={props.open}
            onClose={handleCloseDrawer}
            // ModalProps={{
            //     BackdropProps: {
            //         sx: {
            //             right: "274px",
            //         },
            //     },
            // }}
            PaperProps={{
                sx: {
                    right: "250px",
                    width: 420,
                },
            }}
            sx={{
                display: "flex",
                zIndex: 1500
            }}
        >
            <Box
                sx={{
                    width: {
                        //xs: "100vw",
                        sm: 420,
                    },
                    height: "100%",
                    display: "flex",
                    flexDirection: "column"
                }}
            >
                {/* Header */}
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        p: 1.6,
                    }}
                >
                    <Typography variant="h6">
                        {props.userData ? 'Edição' : 'Cadastro'} de Usuário
                    </Typography>
                </Box>

                {/* Conteúdo */}
                <Box
                    sx={{
                        flex: 1,
                        overflowY: "auto",
                        p: 1,
                    }}
                >
                    <BoxComponent component="div" sx={CampoPedidoStyle}>
                        <LabelComponent htmlFor="nome_cliente" sx={CampoPedidoLabelStyle}>
                            Nome do cliente
                        </LabelComponent>
                        <TextFieldComponent
                            id="nome_cliente"
                            value={dadosUsuario?.nome || ""}
                            onChange={handleChange("nome")}
                            fullWidth
                            disabled={props.userData !== null && props.userData !== undefined && props.userData?.nome !== ""}
                            sx={{ ...CampoPedidoInputStyle }}
                            error={!!errors.nome}
                            helperText={errors.nome}
                            FormHelperTextProps={{
                                sx: {
                                    marginLeft: 0,
                                    marginTop: "12px",
                                    fontSize: "12px"
                                }
                            }}
                        />
                    </BoxComponent>

                    <BoxComponent component="div" sx={{
                        ...CampoPedidoStyle
                    }}>
                        <LabelComponent htmlFor="telefone_cliente" sx={CampoPedidoLabelStyle}>
                            Telefone
                        </LabelComponent>
                        <TextFieldComponent
                            id="telefone_cliente"
                            placeholder=""
                            value={dadosUsuario?.telefoneCompleto}
                            onChange={handleChange("telefoneCompleto")}
                            fullWidth
                            sx={{ ...CampoPedidoInputStyle }}
                            disabled={props.userData !== null && props.userData !== undefined && props.userData?.telefoneCompleto !== ""}
                            maskTelefone
                            error={!!errors.telefone}
                            helperText={errors.telefone}
                        />
                    </BoxComponent>

                    <BoxComponent component="div" sx={{ ...CampoPedidoStyle, display: "flex", flexDirection: "column", gap: 1.5 }}>
                        <LabelComponent htmlFor="" sx={CampoPedidoLabelStyle}>
                            Endereços
                        </LabelComponent>

                        {errors.endereco && (
                            <Typography
                                color="error"
                                fontSize={12}
                            >
                                {errors.endereco}
                            </Typography>
                        )}

                        {!adicionandoEndereco && (
                            <BoxComponent component="div" sx={{ display: "flex", flexDirection: "column", gap: 1.5, overflow: "auto", height: "30%" }}>
                                {enderecos && enderecos.map((element: UsuarioEnderecos, index: number) => {
                                    return <LabelComponent key={`endereco_${index}`} htmlFor={`endereco_${index}`}
                                        sx={{
                                            ...CampoPedidoLabelStyle,
                                            height: '98.39px',
                                            display: 'flex',
                                            gap: 2,
                                            opacity: 1,
                                            borderRadius: '10.4px',
                                            padding: '16.2px',
                                            border: '1px solid #E5E7EB',
                                            boxSizing: 'border-box',
                                            alignItems: '',
                                            verticalAlign: null,
                                        }}
                                    >
                                        <TextFieldComponent
                                            id={`endereco_${index}`}
                                            type="radio"
                                            checked={enderecoSelecionado === index}
                                            onChange={() => setEnderecoSelecionado(index)}
                                            sx={{
                                                width: "10%",
                                                border: "none"
                                            }}
                                        //value={props.userData?.telefoneCompleto}
                                        //onChange={handleChange("telefoneCompleto")}
                                        //fullWidth
                                        //sx={{ ...CampoPedidoInputStyle }}
                                        />

                                        <BoxComponent component="div">
                                            <TypographyComponent
                                                variant="body2" fontWeight="bold"
                                                sx={{
                                                    fontFamily: '"Font 7", sans-serif',
                                                    fontWeight: 600,
                                                    fontSize: '16px',
                                                    lineHeight: '24px',
                                                    letterSpacing: '0%',
                                                    color: '#101828',
                                                    display: 'inline-flex',
                                                    alignItems: 'center',
                                                    verticalAlign: 'middle'
                                                }}
                                            >
                                                {element.nome}
                                            </TypographyComponent>
                                            <TypographyComponent
                                                variant="body2"
                                                sx={{
                                                    fontFamily: '"Font 7", sans-serif',
                                                    fontWeight: 400,
                                                    fontSize: '14px',
                                                    lineHeight: '20px',
                                                    letterSpacing: '0%',
                                                    color: '#4A5565',
                                                    display: 'inline-flex',
                                                    alignItems: 'center',
                                                    verticalAlign: 'middle'
                                                }}
                                            >
                                                {element.enderecoCompleto}
                                            </TypographyComponent>
                                        </BoxComponent>
                                    </LabelComponent>
                                })}

                                {/* {props.userData?.enderecos && props.userData.enderecos.length == 0 && <p>Não tem endereços</p>} */}
                            </BoxComponent>
                        )}

                        {adicionandoEndereco && (
                            <NovoEnderecoFields
                                //token={token}
                                cancelaEndereco={() => handleCancelaEndereco()}
                                onSubmit={(e: any) => handleSaveEndereco(e)}
                                endereco={endereco}
                                onChange={(campo: string, valor: any) => handleChangeEndereco(campo, valor)}

                                /*
                                municipios={municipios}
                                municipio={municipio}
                                onChangeMunicipio={(municipio: MunicipioDTO) => setMunicipio(municipio)}

                                ufs={ufs}
                                */
                            />
                        )}

                        {!adicionandoEndereco && (
                            <ButtonComponent
                                id="botao-add-endereco"
                                onClick={() => {
                                    setAdicionandoEndereco(true);

                                    setEndereco({
                                        ...endereco,
                                        rua: "",
                                        quadra: "",
                                        numero: "",
                                        bairro: "",
                                        cep: "",
                                        cidade: "",
                                        estado: "",
                                        pontoReferencia: ""
                                    } as UsuarioEnderecos);
                                }}
                            >
                                Adicionar novo endereço
                            </ButtonComponent>
                        )}
                    </BoxComponent>
                </Box>
            </Box>
        </Drawer>
    );
}

export default DadosUsuarioDrawer;